/**
 * Loan-activity client (DEV-3636, Skynet.Loans behind the loans gateway).
 * GET /api/loans/activity/since returns recent milestone events for the
 * authenticated user's company over a trailing window (max 30 days, <=50 events).
 * Loan last-4 only — no borrower name.
 *
 * Response shape:
 *   { events: [{ applicationId, loanNumberLast4, milestoneLabel, occurredAt }],
 *     since, asOf }
 */
export class LoanActivityApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getActivitySince({ sinceDays, config = {} } = {}) {
    return this.#http.get('/api/loans/activity/since', { ...config, params: { sinceDays } });
  }

  // DEV-4626 disclosure trail (attestations, remediations, mailed-delivery). The route is keyed
  // by {loanId} but the activity log stores the APPLICATION guid as the loan id, so callers pass
  // applicationId here. eventTypes is a single comma-separated string; take caps the page size.
  async getDisclosureActivity({ applicationId, eventTypes, take, config = {} } = {}) {
    return this.#http.get(`/api/loans/${applicationId}/activity`, {
      ...config,
      params: { eventTypes, take },
    });
  }
}
